import React from 'react'

const NotFound = () => {
    return (
        <div className='card'>
            <h1>Ano...</h1>
            <p className="lead">The page you are looking for does not exist...</p>
        </div>
    )
}

export default NotFound